module.exports = __webpack_public_path__ + "img/google_classroom_logo.e817d44c.png";